import Debug from "debug";
const debug = Debug("router/index.js");

import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "Landing",
    },
  },
  {
    path: "/landing",
    name: "Landing",
    component: () =>
      import(/* webpackChunkName: "Landing" */ "../views/Landing.vue"),
    meta: {},
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Error404",
    component: () =>
      import(/* webpackChunkName: "Error404" */ "../views/Error404.vue"),
    meta: {},
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  debug(`router.beforeEach: (to: ${to}, from: ${from})`);
  next();
});

export default router;
